import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import AdditionalInformations from './AdditionalInformations';
import styles from './styles';
import {
  selectIsGettingUserProfile,
  selectPersonalProfileFormMode,
  selectBusinessProfileFormMode,
  selectServiceAreaFormMode,
  selectAdditionalInfoFormMode,
} from '../../store/selectors';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  isGettingUserProfile: PropTypes.bool.isRequired,
  userAttributes: PropTypes.object.isRequired,
  setBuilder: PropTypes.func.isRequired,
};

const AdditionalInformationContainer = props => {
  const { classes, isGettingUserProfile, userAttributes, setBuilder } = props;

  if (isGettingUserProfile) {
    return (
      <div className={classes.progressWrapper}>
        <CircularProgress className={classes.progress} />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.innerWrapper}>
        <div className={classes.personalWrapper}>
          <AdditionalInformations
            enableEditing
            userAttributes={userAttributes}
            setBuilder={setBuilder}
          />
        </div>
      </div>
    </div>
  );
};

AdditionalInformationContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  isGettingUserProfile: selectIsGettingUserProfile(),
  personalProfileFormMode: selectPersonalProfileFormMode(),
  businessProfileFormMode: selectBusinessProfileFormMode(),
  additionalInfoFormMode: selectAdditionalInfoFormMode(),
  serviceAreaFormMode: selectServiceAreaFormMode(),
});

export default withStyles(styles)(
  connect(mapStateToProps)(AdditionalInformationContainer),
);
